module.exports = __webpack_public_path__ + "img/commandcenter_parked.9441a0db.svg";